export const envTypes = {
    BETA: 'BETA',
    STAGING: 'STAGING',
    PRODUCTION: 'PRODUCTION',
    DEVELOPMENT: 'DEVELOPMENT',
}
